<template>
    <v-row class="white-card" align="center" dense>
        <v-col cols="6" class="h5">
            {{ $t('statistics.wellness') }}
        </v-col>
        <v-col cols="6" align="right">
            <group-by-selector
                v-if="!noData" no-monthly
                @change="currentGroupBy = $event"
                :value="currentGroupBy"
            />
        </v-col>
        <v-col cols="2" v-if="!noData">
            <v-row>
                <v-col cols="12" class="small">
                    {{ $t('statistics.stressed') }}
                </v-col>
                <v-col cols="12" class="small">
                    {{ $t('statistics.tired') }}
                </v-col>
                <v-col cols="12" class="small">
                    {{ $t('statistics.muscles_hurt') }}
                </v-col>
                <v-col cols="12" class="small">
                    {{ $t('statistics.sleep_night') }}
                </v-col>
            </v-row>
        </v-col>
        <v-col :cols="noData ? 12 : 10">
            <div v-if="noData" class="card-no-data">
                <div>
                    <v-icon large color="#6FCF97">mdi-magnify-close</v-icon>
                    <div class="p1 mt-1">
                        {{ $t('common.without_data') }}
                    </div>
                </div>
            </div>
            <bar-chart
                v-else
                :labels="labels"
                :datasets="datasets"
                style="height: 280px"
            />
        </v-col>
    </v-row>
</template>

<script>
import GroupBySelector from "@/components/statistics/GroupBySelector";
import BarChart from "@/components/common/BarChart";
import _groupBy from 'lodash/groupBy'

export default {
    name: "Wellness",
    components: {BarChart, GroupBySelector},
    props: {
        docs: {
            type: Array,
            default: null,
        }
    },
    data() {
        return {
            currentGroupBy: 'daily',
            datasets: [],
            labels: [],
            colors: ['#333333', '#078571', '#CCFF99', '#999999']
        }
    },
    computed: {
        noData(vm = this) {
            return vm.docs.length === 0
        },
        docsGrouped(vm = this) {
            let docs = vm.docs.map(doc => {
                let date = vm.$moment(doc.rawDate.full)
                if (vm.currentGroupBy === 'weekly') date = date.startOf('week')
                return {
                    date: date,
                    dateString: date.format('DD MMM').replace('.', ''),
                    sleep_night: Number(doc?.advance?.preInfo?.sleep_night || 1),
                    muscles_hurt: Number(doc?.advance?.preInfo?.muscles_hurt || 1),
                    tired: Number(doc?.advance?.preInfo?.tired || 1),
                    stressed: Number(doc?.advance?.preInfo?.stressed || 1),
                }
            })

            if (vm.currentGroupBy !== 'daily') {
                let grouped = _groupBy(docs, d => {
                    return d.dateString
                })

                docs = []
                for (let currentDate in grouped) {
                    if (grouped[currentDate].length === 1) {
                        docs.push(grouped[currentDate][0])
                    } else {
                        let sleep_night = 0
                        let muscles_hurt = 0
                        let tired = 0
                        let stressed = 0
                        grouped[currentDate].forEach(group => {
                            sleep_night += group.sleep_night
                            muscles_hurt += group.muscles_hurt
                            tired += group.tired
                            stressed += group.stressed
                        })
                        docs.push({
                            date: grouped[currentDate][0].date,
                            dateString: grouped[currentDate][0].dateString,
                            sleep_night: sleep_night,
                            muscles_hurt: muscles_hurt,
                            tired: tired,
                            stressed: stressed,
                        })
                    }
                }
            }

            return docs
        }
    },
    mounted() {
        const vm = this
        vm.loadStats()
    },
    methods: {
        loadStats() {
            const vm = this

            let labels = []
            let sleep_night = []
            let muscles_hurt = []
            let tired = []
            let stressed = []
            let days = []

            vm.docsGrouped.forEach(doc => {
                labels.push(doc.sleep_night + doc.muscles_hurt + doc.tired + doc.stressed)
                stressed.push(doc.stressed)
                tired.push(doc.tired)
                muscles_hurt.push(doc.muscles_hurt)
                sleep_night.push(doc.sleep_night)
                days.push(doc.dateString)
            })

            vm.labels = labels
            vm.datasets = [
                {data: sleep_night, backgroundColor: vm.colors[0], barPercentage: 0.2},
                {data: muscles_hurt, backgroundColor: vm.colors[1], barPercentage: 0.2},
                {data: tired, backgroundColor: vm.colors[2], barPercentage: 0.2},
                {data: stressed, backgroundColor: vm.colors[3], days: days, barPercentage: 0.2},
            ]
        }
    },
    watch: {
        docsGrouped() {
            this.loadStats()
        }
    }
}
</script>

<style scoped>

</style>